import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor(private httpClient: HttpClient) {}

  private apiUrl: string = environment.api + '/v2';

  public getAllEnvironments(): Observable<Array<Environment>> {
    return this.httpClient.get<Environment[]>(`${this.apiUrl}/environment/all`);
  }

  public createEnvironment(
    template: Partial<Environment>,
  ): Observable<Environment> {
    return this.httpClient.post<Environment>(
      `${this.apiUrl}/environment/`,
      template,
    );
  }

  public getEnvironmentById(id: string): Observable<Environment> {
    return this.httpClient.get<Environment>(`${this.apiUrl}/environment/${id}`);
  }

  public updateEnvironment(
    id: string,
    templateData: Partial<Environment>,
  ): Observable<Environment> {
    return this.httpClient.put<Environment>(
      `${this.apiUrl}/environment/${id}`,
      templateData,
    );
  }

  public deleteEnvironment(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiUrl}/environment/${id}`);
  }
}
